module.exports = __webpack_public_path__ + "files/ba2d19880e15bf8585bf2898f5680083.png";